import React from 'react';

export const PricePointsIcon = (props) => (
  <svg viewBox="0 0 76 73" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.6182 9.79463L38.5824 7.64812C37.4929 7.53695 36.4112 7.92184 35.6368 8.69624L4.72702 39.606C3.30444 41.0286 3.30444 43.335 4.72702 44.7576L27.9093 67.9399C29.3319 69.3625 31.6384 69.3625 33.061 67.9399L63.9707 37.0302C64.7451 36.2558 65.13 35.1741 65.0188 34.0846L62.8723 13.0488C62.6969 11.3295 61.3375 9.97007 59.6182 9.79463ZM55.9265 16.7396L57.5957 33.1012L30.4852 60.2116L12.4546 42.1809L39.565 15.0705L55.9265 16.7396ZM49.8774 33.2394C47.0322 36.0845 42.4193 36.0845 39.5742 33.2394C36.729 30.3942 36.729 25.7813 39.5742 22.9361C42.4193 20.091 47.0322 20.091 49.8774 22.9361C52.7226 25.7813 52.7226 30.3942 49.8774 33.2394Z"
    />
  </svg>
);

export default PricePointsIcon;
